export default __webpack_public_path__ + "static/media/circleOnTopLeft.37470364.svg";